import AboutModal from './AboutModal.json';
import Buttons from './Buttons.json';
import CineDialog from './CineDialog.json';
import Common from './Common.json';
import DatePicker from './DatePicker.json';
// PARCHE CABSEN (2026-10-09): OHIF no trae ErrorBoundary.json en espanol y el aviso de error generico
// ("Something went wrong") salia en ingles.
import ErrorBoundary from './ErrorBoundary.json';
import Header from './Header.json';
import MeasurementTable from './MeasurementTable.json';
// PARCHE CABSEN (2026-09-14): OHIF no trae Modes.json en espanol, asi que el boton del modo longitudinal
// caia al ingles ("Basic Viewer"). Aqui se llama "Visor completo", en pareja con nuestro "Visor basico".
import Modes from './Modes.json';
import DataRow from './DataRow.json';
import SidePanel from './SidePanel.json';
import StudyBrowser from './StudyBrowser.json';
import StudyList from './StudyList.json';
import UserPreferencesModal from './UserPreferencesModal.json';
import ViewportDownloadForm from './ViewportDownloadForm.json';

export default {
  es: {
    AboutModal,
    Buttons,
    CineDialog,
    Common,
    DatePicker,
    ErrorBoundary,
    Header,
    MeasurementTable,
    Modes,
    DataRow,
    SidePanel,
    StudyBrowser,
    StudyList,
    UserPreferencesModal,
    ViewportDownloadForm,
  },
};
